<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link
        class="brand-logo"
        :href="platformUrl()"
      >
        <platform-logo />
        <h2 class="brand-text text-primary ml-1">
          {{ platformName() }}
        </h2>
        <small
          v-if="platformVersionName()"
          class="pl-50"
        >
          {{ platformVersionName() }}
        </small>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-text class="mb-2" />

          <div class="text-center">
            <b-spinner
              variant="primary"
              label="Please wait ..."
            />
          </div>

        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
    <div id="hiddenBtn" />
  </div>
</template>

<script>
/* eslint-disable global-require */
import PlatformLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BCardText,
  BImg,
  VBTooltip, BSpinner,
} from 'bootstrap-vue'
import useSession from '@/auth/jwt/useJwt'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'

import {
  catchException, dashboardHost, platformName, platformUrl, platformVersionName,
} from '@core/utils/utils'
import jwtDefaultConfig from "@core/auth/jwt/jwtDefaultConfig";

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BSpinner,
    BRow,
    BCol,
    BLink,
    BCardText,
    BImg,
    PlatformLogo,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      isLoading: false,
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      errors: {
      },
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  beforeMount() {
    this.generatePreviewSession()
  },
  mounted() {
  },
  methods: {
    platformUrl,
    platformVersionName,
    platformName,
    generatePreviewSession() {
      this.isLoading = true
      useSession.csrf().then(() => {
        this.$http.get(`/${jwtDefaultConfig.DASHBOARD_ENDPOINT}/store/preview`, {
          params: this.$route.query,
        })
          .then(response => {
            window.location.href = response.data.data.url
          })
          .catch(error => {
            catchException(error)
            window.location.href = dashboardHost()
          })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
